import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../modules/resources";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import withPagination from "Components/withPagination";
import { alertError, alertSuccess } from "Utils/alerts";
import Button from "Components/button/Button";
import PropTypes from "prop-types";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";
import FullPaginationControls from "Components/fullPaginationControls/FullPaginationControls";
import TranslatedString from "Components/TranslatedString";
import { Icon, notFound, plus, delegate } from "Icons/index";
import t from "Utils/translation";
import Loader from "Components/loader/Loader";
import FirstView from "./FirstView";
import DelegateCard from "Components/delegateCard/DelegateCard";
import Pager from "Components/pager/Pager";
import withConfirmationModal from "Components/withConfirmationModal";
import qs from "query-string";
import cx from "classnames";
import s from "./listDelegates.scss";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class DelegatesListScreen extends React.Component {
  constructor(props) {
    super(props);

    this.showDelegate = this.showDelegate.bind(this);
    this.addNew = this.addNew.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.changeDelegateStatus = this.changeDelegateStatus.bind(this);
    this.deleteDelegate = this.deleteDelegate.bind(this);

    this.state = {
      customer_code: undefined,
      isMenuOpen: false,
      confirmModalOpened: false,
      selectedDomain: {},
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getDelegates(this.props.location.search);
    this.props.getArchiveDomains();
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.setState({ isMenuOpen: false });
  }

  addNew() {
    this.props.history.push("/delegates/new");
  }

  showDelegate(code) {
    this.props.history.push({
      pathname: `/delegates/${code}`,
      state: {
        prevPagination: this.props.location.search,
      },
    });
  }

  deleteDelegate(code) {
    this.props.deleteDelegate(code);
    this.props.optimisticallyDeleteResource(code);
    alertSuccess(t("alert.delegateDeletedSuccess"));
  }

  changeDelegateStatus(code, status, isCustomerDisabled) {
    if (status === "enabled" && isCustomerDisabled) {
      alertError(t("alert.customer.disabled"));
    } else {
      this.props.changeDelegateStatus(code, status);
      this.props.changeStatus(code, status);
    }
  }

  render() {
    const {
      delegates,
      areDelegatesLoading,
      paginationInfo,
      archiveDomains,
      areDomainsLoading,
      location,
      refreshList,
      isRefreshing,
      delegatesTotals,
    } = this.props;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    const loggedUser = this.context.getLoggedUser();
    let canManageDelegate = true;
    let canEnableDelegate = true;
    if (loggedUser.type === "TeamMember") {
      if (!loggedUser.permissions.includes("manage_vault_delegate")) {
        canManageDelegate = false;
      }

      // if (!loggedUser.permissions.includes("disable_vault_delegate")) {
      //   canEnableDelegate = false;
      // }
    }

    const query = qs.parse(location.search);

    // let content;
    //
    // if (areDelegatesLoading) {
    //   content = <Loader {...this.props} />;
    // } else {
    let content = _.map(delegates, (man) => (
      <DelegateCard
        {...man}
        key={man.code}
        showDelegate={this.showDelegate}
        changeDelegateStatus={this.changeDelegateStatus}
        canManageDelegate={canManageDelegate}
        canEnableDelegate={canEnableDelegate}
        delete={() =>
          this.props.openConfirmationModal(
            man,
            this.deleteDelegate,
            <TranslatedString subs={{ name: man.fullname }}>modal.delete.archive.delegate.text</TranslatedString>
          )
        }
      />
    ));

    if (
      content.length == 0 &&
      !query.status &&
      !query.customer_code &&
      !areDelegatesLoading &&
      !query.query &&
      !areDomainsLoading
    ) {
      return <FirstView hasArchive={archiveDomains.length > 0} />;
    }

    return (
      <div className={s.listDelegates}>
        <div className={s.headerList}>
          <div className={cx("sectionTitle", s.titleList)}>{t("delegates.list.header.title")}</div>

          {!isMediaMobile() && (
            <div className={cx("sectionDesc", s.descList)}>
              <TranslatedString>delegates.list.header.dsc</TranslatedString>
            </div>
          )}

          <div className={s.actionsList}>
            <Button docsKey="delegates" color="docs" className={s.btnList} onlyIcon={isMediaMobile()}>
              button.docs
            </Button>
            {canManageDelegate && (
              <Button icon={plus} onClick={this.addNew} onlyIcon={isMediaMobile()}>
                button.add.delegate
              </Button>
            )}
          </div>
        </div>

        <div className={s.contentList}>
          <FullPaginationControls
            className={s.filters}
            paginationInfo={paginationInfo}
            location={location}
            refreshList={refreshList}
            listFilters={["all", "enabled", "disabled"]}
            listFilterLegends={{
              all: <Icon svg={delegate} width="0.75rem" height="0.75rem" />,
              enabled: <DomainStatusBadge status="enabled" isHealthy showAsPreview />,
              disabled: <DomainStatusBadge status="disabled" isHealthy showAsPreview />,
            }}
            showCustomerSelection={this.context.isLoggedUserAdmin()}
            isLoading={areDelegatesLoading || isRefreshing}
            totals={delegatesTotals}
          />

          {areDelegatesLoading && <Loader className={s.loader} />}

          {!areDelegatesLoading && content.length === 0 && (
            <div className={s.noFoundMsg}>
              <div className={s.wrpaIllustration}>
                <Icon svg={notFound} width="10rem" height="10rem" />
                <div className={s.msgIllustration}>{t("infoMsg.noRecords.msg")}</div>
                <div className={s.descIllustration}>{t("infoMsg.noRecords.desc")}</div>
              </div>
            </div>
          )}

          {!areDelegatesLoading && content.length > 0 && <div className={s.table}>{content}</div>}
        </div>
      </div>
    );
  }
}

//DelegatesListScreen.propTypes = propTypes;
DelegatesListScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  archiveDomains: resActions.getData("archiveDomains.data", state),
  areDomainsLoading: resActions.isResourceLoading("archiveDomains", state),
  delegates: resActions.getData("delegates.data", state),
  delegatesTotals: resActions.getData("delegates.paginationInfo.totals", state),
  paginationInfo: resActions.getData("delegates.paginationInfo", state),
  areDelegatesLoading: resActions.isResourceLoading("delegates", state),
});

const mapDispatchToProps = (dispatch) => ({
  getArchiveDomains: (queryParams) => dispatch(resActions.callApi("getArchiveDomains", "archiveDomains", queryParams)),
  getDelegates: (queryParams) => dispatch(resActions.callApi("getDelegates", "delegates", queryParams)),
  retrievePagination: (queryParams) => dispatch(resActions.callApi("getDelegates", "delegates", queryParams)),
  refreshDelegates: (queryParams) => dispatch(resActions.callApi("refreshDelegates", "delegates", queryParams)),
  deleteDelegate: (code) => dispatch(resActions.callApi("deleteDelegate", "delegates", code)),
  changeDelegateStatus: (code, status) =>
    dispatch(resActions.callApi("changeDelegateStatus", "delegate", code, status)),
  changeStatus: (resourceCode, newValue) =>
    dispatch(
      resActions.changeAttribute(newValue, {
        resourcesType: "delegates",
        resourceCode,
        resourceAttribute: "status",
      })
    ),
  changeStatusDetail: (resourceCode, newValue) =>
    dispatch(
      resActions.changeAttribute(newValue, {
        resourcesType: "delegates",
        resourceCode,
        resourceAttribute: "status_detail",
      })
    ),
  optimisticallyDeleteResource: (resourceCode) =>
    dispatch(
      resActions.optimisticallyDeleteResource({
        resourcesType: "delegates",
        resourceCode,
      })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withConfirmationModal(withPagination(DelegatesListScreen), {
    title: <TranslatedString>modal.delete.archive.delegate.title</TranslatedString>,
    buttonLabel: "button.delete",
  })
);
